export default {
      id: "icon-calendarthin-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "icons.svg#icon-calendarthin",
      toString: function () {
        return this.url;
      }
    }